import React from 'react'
import { Link } from 'react-router-dom'

const MainListItem = ({user, allowedRoles, icon, caption, path}) => {
    if (user.system_role !== "admin" && allowedRoles.filter(r => r === user.system_role).length === 0) {
        return null
    }
    if (path === undefined) {
        path = "#"
    }
    return (
        <li>
            <Link to={path}>

            <div className="mainmenuicon">
                {icon}
                {caption}
            </div>

            </Link>
        </li>
    )
}

export default MainListItem
